import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import { NoProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/NoProgressionActions'

export interface NoProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const NoProgressionActionsContainer = observer(
  function NoProgressionActionsContainer({
    vm,
  }: NoProgressionActionsContainerProps) {
    return (
      <NoProgressionActions
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        onBeginJob={vm.answerJobStarted}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
          )
        }
      />
    )
  },
)
